module.exports = __webpack_public_path__ + "static/img/bg1.270625c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/bg1.png
// module id = rYQY
// module chunks = 69